export const TEST_IDS = {
  nav: {
    home: "nav-home",
    wardrobe: "nav-wardrobe",
    outfit: "nav-outfit",
    stylist: "nav-stylist",
    tryon: "nav-tryon",
    shopping: "nav-shopping",
    community: "nav-community",
    family: "nav-family",
    travel: "nav-travel",
    calendar: "nav-calendar",
    collections: "nav-collections",
    atelier: "nav-atelier",
    profile: "nav-profile",
    themeToggle: "theme-toggle",
    logout: "logout-btn",
  },
  login: {
    googleBtn: "google-login-btn",
  },
  onboarding: {
    next: "onboarding-next-btn",
    back: "onboarding-back-btn",
    finish: "onboarding-finish-btn",
    skip: "onboarding-skip-btn",
  },
  wardrobe: {
    uploadInput: "wardrobe-upload-input",
    uploadBtn: "wardrobe-upload-btn",
    item: (id) => `wardrobe-item-${id}`,
    statusSelect: (id) => `wardrobe-status-${id}`,
    deleteBtn: (id) => `wardrobe-delete-${id}`,
  },
  outfit: {
    generateBtn: "outfit-generate-btn",
    occasionSelect: "outfit-occasion-select",
    result: "outfit-result",
  },
  stylist: {
    input: "stylist-input",
    sendBtn: "stylist-send-btn",
    message: (i) => `stylist-msg-${i}`,
  },
  tryon: {
    generateBtn: "tryon-generate-btn",
    result: "tryon-result",
    itemPick: (id) => `tryon-item-${id}`,
  },
  shopping: {
    refreshBtn: "shopping-refresh-btn",
    card: (i) => `shopping-card-${i}`,
  },
  community: {
    composer: "community-composer",
    postBtn: "community-post-btn",
    likeBtn: (id) => `community-like-${id}`,
  },
  profile: {
    upgradeBtn: "profile-upgrade-btn",
  },
};

export const HOME = { emergentLink: "emergent-link" };
